var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
var ROWS = 4;
var ROW_HEIGHT = 7; // Height of each row in pixels
var SPAN_ROTATION_PADDING = 7; // Padding to subtract from rotation height
var SPAN_HEIGHT = ROW_HEIGHT * ROWS; // Height of each row in pixels
var BORDER_COLOR = '#d1d5db'; // Tailwind's gray-300
var TIME_LABELS = Array.from({ length: 24 }, function (_, i) {
    var hour = i % 12 || 12; // Convert 0 to 12 for AM/PM format
    var period = i < 12 ? 'AM' : 'PM';
    return "".concat(hour, " ").concat(period);
});
var SVG_BACKGROUND = "\n<svg height=\"".concat(SPAN_HEIGHT, "\" width=\"").concat(SPAN_HEIGHT, "px\" xmlns=\"http://www.w3.org/2000/svg\">\n  <line x1=\"0\" y1=\"0\" x2=\"").concat(SPAN_HEIGHT, "\" y2=\"0\" style=\"stroke:").concat(BORDER_COLOR, ";stroke-width:1\" />\n</svg>\n");
var SERVICE_STATUS = [{
        label: 'Available',
        value: 'available',
    }, {
        label: 'No Service',
        value: 'no_service',
    }, {
        label: 'No Service',
        value: 'no_service_holiday',
    },
    {
        label: 'Store Hours',
        value: 'store_hours',
    }, {
        label: 'Available',
        value: 'available_new',
    }, {
        label: 'No Service',
        value: 'no_service_new',
    }, {
        label: 'Override',
        value: 'override',
    }, {
        label: 'Override',
        value: 'override_future',
    }, {
        label: 'No Service',
        value: 'override_no_service',
    }, {
        label: 'Default',
        value: 'default',
    }];
var US_HOLIDAYS = [
    {
        label: 'None', value: 'none', month: 0, day: 0,
    },
    {
        value: 'new_years_day', label: "New Year's Day", day: 1, month: 1,
    },
    {
        value: 'memorial_day', label: 'Memorial Day', day: 26, month: 5,
    },
    {
        value: 'independence_day', label: 'Independence Day', day: 4, month: 7,
    },
    {
        value: 'labor_day', label: 'Labor Day', day: 1, month: 9,
    },
    {
        value: 'thanksgiving_day', label: 'Thanksgiving', day: 27, month: 11,
    },
    {
        value: 'christmas_day', label: 'Christmas', day: 25, month: 12,
    },
    {
        value: 'christmas_eve_day', label: 'Christmas Eve', day: 24, month: 12,
    },
    {
        value: 'new_years_eve_day', label: "New Year's Eve", day: 31, month: 12,
    },
];
var CA_HOLIDAYS = [
    {
        value: 'new_years_day', label: "New Year's Day", day: 1, month: 1,
    },
    {
        value: 'day_after_new_years_day', label: "Day After New Year's Day", day: 2, month: 1,
    },
    {
        value: 'ns_heritage_day', label: 'NS Heritage Day', day: 17, month: 2,
    },
    {
        value: 'good_friday', label: 'Good Friday', day: 18, month: 4,
    },
    {
        value: 'jean_baptiste_day', label: 'St. Jean Baptiste Day', day: 24, month: 6,
    },
    {
        value: 'canada_day', label: 'Canada Day', day: 1, month: 7,
    },
    {
        value: 'labour_day', label: 'Labour Day', day: 1, month: 9,
    },
    {
        value: 'thanksgiving_day', label: 'Thanksgiving', day: 13, month: 10,
    },
    {
        value: 'christmas_day', label: 'Christmas', day: 25, month: 12,
    },
    {
        value: 'christmas_eve_day', label: 'Christmas Eve', day: 24, month: 12,
    },
    {
        value: 'boxing_day', label: 'Boxing Day', day: 26, month: 12,
    },
    {
        value: 'new_years_eve_day', label: "New Year's Eve", day: 31, month: 12,
    },
];
export { MONTHS, DAYS, ROWS, BORDER_COLOR, TIME_LABELS, ROW_HEIGHT, SPAN_HEIGHT, SPAN_ROTATION_PADDING, SVG_BACKGROUND, SERVICE_STATUS, US_HOLIDAYS, CA_HOLIDAYS, };
//# sourceMappingURL=const.js.map